export function onlyDigits(v: string) {
  return v.replace(/\D/g, '');
}

/* =========================  Country type  ========================= */
export type Country = {
  iso: string;        // ISO 3166-1 alpha-2 (lowercase) — used for flag URL
  code: string;       // dial code (e.g. '55')
  name: string;       // display name
  maxDigits: number;  // max phone digits (without dial code)
};

/** Flag image URL from flagcdn.com (free, no API key) */
export function flagUrl(iso: string, w = 40): string {
  return `https://flagcdn.com/w${w}/${iso}.png`;
}

/* =========================  ALL countries  ========================= */
export const COUNTRIES: Country[] = [
  { iso: 'af', code: '93',   name: 'Afghanistan',                  maxDigits: 9  },
  { iso: 'al', code: '355',  name: 'Albania',                      maxDigits: 9  },
  { iso: 'dz', code: '213',  name: 'Algeria',                      maxDigits: 9  },
  { iso: 'ad', code: '376',  name: 'Andorra',                      maxDigits: 9  },
  { iso: 'ao', code: '244',  name: 'Angola',                       maxDigits: 9  },
  { iso: 'ag', code: '1268', name: 'Antigua & Barbuda',            maxDigits: 10 },
  { iso: 'ar', code: '54',   name: 'Argentina',                    maxDigits: 12 },
  { iso: 'am', code: '374',  name: 'Armenia',                      maxDigits: 8  },
  { iso: 'au', code: '61',   name: 'Australia',                    maxDigits: 9  },
  { iso: 'at', code: '43',   name: 'Austria',                      maxDigits: 13 },
  { iso: 'az', code: '994',  name: 'Azerbaijan',                   maxDigits: 9  },
  { iso: 'bs', code: '1242', name: 'Bahamas',                      maxDigits: 10 },
  { iso: 'bh', code: '973',  name: 'Bahrain',                      maxDigits: 8  },
  { iso: 'bd', code: '880',  name: 'Bangladesh',                   maxDigits: 10 },
  { iso: 'bb', code: '1246', name: 'Barbados',                     maxDigits: 10 },
  { iso: 'by', code: '375',  name: 'Belarus',                      maxDigits: 10 },
  { iso: 'be', code: '32',   name: 'Belgium',                      maxDigits: 9  },
  { iso: 'bz', code: '501',  name: 'Belize',                       maxDigits: 7  },
  { iso: 'bj', code: '229',  name: 'Benin',                        maxDigits: 8  },
  { iso: 'bt', code: '975',  name: 'Bhutan',                       maxDigits: 8  },
  { iso: 'bo', code: '591',  name: 'Bolivia',                      maxDigits: 8  },
  { iso: 'ba', code: '387',  name: 'Bosnia & Herzegovina',         maxDigits: 8  },
  { iso: 'bw', code: '267',  name: 'Botswana',                     maxDigits: 8  },
  { iso: 'br', code: '55',   name: 'Brasil',                       maxDigits: 11 },
  { iso: 'bn', code: '673',  name: 'Brunei',                       maxDigits: 7  },
  { iso: 'bg', code: '359',  name: 'Bulgaria',                     maxDigits: 9  },
  { iso: 'bf', code: '226',  name: 'Burkina Faso',                 maxDigits: 8  },
  { iso: 'bi', code: '257',  name: 'Burundi',                      maxDigits: 8  },
  { iso: 'cv', code: '238',  name: 'Cabo Verde',                   maxDigits: 7  },
  { iso: 'kh', code: '855',  name: 'Cambodia',                     maxDigits: 9  },
  { iso: 'cm', code: '237',  name: 'Cameroon',                     maxDigits: 9  },
  { iso: 'ca', code: '1',    name: 'Canada',                       maxDigits: 10 },
  { iso: 'cf', code: '236',  name: 'Central African Republic',     maxDigits: 8  },
  { iso: 'td', code: '235',  name: 'Chad',                         maxDigits: 8  },
  { iso: 'cl', code: '56',   name: 'Chile',                        maxDigits: 9  },
  { iso: 'cn', code: '86',   name: 'China',                        maxDigits: 11 },
  { iso: 'co', code: '57',   name: 'Colombia',                     maxDigits: 10 },
  { iso: 'km', code: '269',  name: 'Comoros',                      maxDigits: 7  },
  { iso: 'cg', code: '242',  name: 'Congo',                        maxDigits: 9  },
  { iso: 'cd', code: '243',  name: 'Congo (DRC)',                  maxDigits: 9  },
  { iso: 'cr', code: '506',  name: 'Costa Rica',                   maxDigits: 8  },
  { iso: 'ci', code: '225',  name: 'Côte d\'Ivoire',               maxDigits: 10 },
  { iso: 'hr', code: '385',  name: 'Croatia',                      maxDigits: 9  },
  { iso: 'cu', code: '53',   name: 'Cuba',                         maxDigits: 8  },
  { iso: 'cy', code: '357',  name: 'Cyprus',                       maxDigits: 8  },
  { iso: 'cz', code: '420',  name: 'Czech Republic',               maxDigits: 9  },
  { iso: 'dk', code: '45',   name: 'Denmark',                      maxDigits: 8  },
  { iso: 'dj', code: '253',  name: 'Djibouti',                     maxDigits: 8  },
  { iso: 'dm', code: '1767', name: 'Dominica',                     maxDigits: 10 },
  { iso: 'do', code: '1809', name: 'Dominican Republic',           maxDigits: 10 },
  { iso: 'ec', code: '593',  name: 'Ecuador',                      maxDigits: 9  },
  { iso: 'eg', code: '20',   name: 'Egypt',                        maxDigits: 10 },
  { iso: 'sv', code: '503',  name: 'El Salvador',                  maxDigits: 8  },
  { iso: 'gq', code: '240',  name: 'Equatorial Guinea',            maxDigits: 9  },
  { iso: 'er', code: '291',  name: 'Eritrea',                      maxDigits: 7  },
  { iso: 'ee', code: '372',  name: 'Estonia',                      maxDigits: 8  },
  { iso: 'sz', code: '268',  name: 'Eswatini',                     maxDigits: 8  },
  { iso: 'et', code: '251',  name: 'Ethiopia',                     maxDigits: 9  },
  { iso: 'fj', code: '679',  name: 'Fiji',                         maxDigits: 7  },
  { iso: 'fi', code: '358',  name: 'Finland',                      maxDigits: 10 },
  { iso: 'fr', code: '33',   name: 'France',                       maxDigits: 9  },
  { iso: 'ga', code: '241',  name: 'Gabon',                        maxDigits: 8  },
  { iso: 'gm', code: '220',  name: 'Gambia',                       maxDigits: 7  },
  { iso: 'ge', code: '995',  name: 'Georgia',                      maxDigits: 9  },
  { iso: 'de', code: '49',   name: 'Germany',                      maxDigits: 12 },
  { iso: 'gh', code: '233',  name: 'Ghana',                        maxDigits: 9  },
  { iso: 'gr', code: '30',   name: 'Greece',                       maxDigits: 10 },
  { iso: 'gd', code: '1473', name: 'Grenada',                      maxDigits: 10 },
  { iso: 'gt', code: '502',  name: 'Guatemala',                    maxDigits: 8  },
  { iso: 'gn', code: '224',  name: 'Guinea',                       maxDigits: 9  },
  { iso: 'gw', code: '245',  name: 'Guinea-Bissau',                maxDigits: 7  },
  { iso: 'gy', code: '592',  name: 'Guyana',                       maxDigits: 7  },
  { iso: 'ht', code: '509',  name: 'Haiti',                        maxDigits: 8  },
  { iso: 'hn', code: '504',  name: 'Honduras',                     maxDigits: 8  },
  { iso: 'hk', code: '852',  name: 'Hong Kong',                    maxDigits: 8  },
  { iso: 'hu', code: '36',   name: 'Hungary',                      maxDigits: 9  },
  { iso: 'is', code: '354',  name: 'Iceland',                      maxDigits: 7  },
  { iso: 'in', code: '91',   name: 'India',                        maxDigits: 10 },
  { iso: 'id', code: '62',   name: 'Indonesia',                    maxDigits: 12 },
  { iso: 'ir', code: '98',   name: 'Iran',                         maxDigits: 10 },
  { iso: 'iq', code: '964',  name: 'Iraq',                         maxDigits: 10 },
  { iso: 'ie', code: '353',  name: 'Ireland',                      maxDigits: 9  },
  { iso: 'il', code: '972',  name: 'Israel',                       maxDigits: 9  },
  { iso: 'it', code: '39',   name: 'Italy',                        maxDigits: 10 },
  { iso: 'jm', code: '1876', name: 'Jamaica',                      maxDigits: 10 },
  { iso: 'jp', code: '81',   name: 'Japan',                        maxDigits: 10 },
  { iso: 'jo', code: '962',  name: 'Jordan',                       maxDigits: 9  },
  { iso: 'kz', code: '7',    name: 'Kazakhstan',                   maxDigits: 10 },
  { iso: 'ke', code: '254',  name: 'Kenya',                        maxDigits: 10 },
  { iso: 'ki', code: '686',  name: 'Kiribati',                     maxDigits: 8  },
  { iso: 'kw', code: '965',  name: 'Kuwait',                       maxDigits: 8  },
  { iso: 'kg', code: '996',  name: 'Kyrgyzstan',                   maxDigits: 9  },
  { iso: 'la', code: '856',  name: 'Laos',                         maxDigits: 10 },
  { iso: 'lv', code: '371',  name: 'Latvia',                       maxDigits: 8  },
  { iso: 'lb', code: '961',  name: 'Lebanon',                      maxDigits: 8  },
  { iso: 'ls', code: '266',  name: 'Lesotho',                      maxDigits: 8  },
  { iso: 'lr', code: '231',  name: 'Liberia',                      maxDigits: 9  },
  { iso: 'ly', code: '218',  name: 'Libya',                        maxDigits: 10 },
  { iso: 'li', code: '423',  name: 'Liechtenstein',                maxDigits: 9  },
  { iso: 'lt', code: '370',  name: 'Lithuania',                    maxDigits: 8  },
  { iso: 'lu', code: '352',  name: 'Luxembourg',                   maxDigits: 9  },
  { iso: 'mo', code: '853',  name: 'Macau',                        maxDigits: 8  },
  { iso: 'mg', code: '261',  name: 'Madagascar',                   maxDigits: 10 },
  { iso: 'mw', code: '265',  name: 'Malawi',                       maxDigits: 9  },
  { iso: 'my', code: '60',   name: 'Malaysia',                     maxDigits: 10 },
  { iso: 'mv', code: '960',  name: 'Maldives',                     maxDigits: 7  },
  { iso: 'ml', code: '223',  name: 'Mali',                         maxDigits: 8  },
  { iso: 'mt', code: '356',  name: 'Malta',                        maxDigits: 8  },
  { iso: 'mh', code: '692',  name: 'Marshall Islands',             maxDigits: 7  },
  { iso: 'mr', code: '222',  name: 'Mauritania',                   maxDigits: 8  },
  { iso: 'mu', code: '230',  name: 'Mauritius',                    maxDigits: 8  },
  { iso: 'mx', code: '52',   name: 'México',                       maxDigits: 10 },
  { iso: 'fm', code: '691',  name: 'Micronesia',                   maxDigits: 7  },
  { iso: 'md', code: '373',  name: 'Moldova',                      maxDigits: 8  },
  { iso: 'mc', code: '377',  name: 'Monaco',                       maxDigits: 9  },
  { iso: 'mn', code: '976',  name: 'Mongolia',                     maxDigits: 8  },
  { iso: 'me', code: '382',  name: 'Montenegro',                   maxDigits: 8  },
  { iso: 'ma', code: '212',  name: 'Morocco',                      maxDigits: 9  },
  { iso: 'mz', code: '258',  name: 'Mozambique',                   maxDigits: 9  },
  { iso: 'mm', code: '95',   name: 'Myanmar',                      maxDigits: 10 },
  { iso: 'na', code: '264',  name: 'Namibia',                      maxDigits: 10 },
  { iso: 'nr', code: '674',  name: 'Nauru',                        maxDigits: 7  },
  { iso: 'np', code: '977',  name: 'Nepal',                        maxDigits: 10 },
  { iso: 'nl', code: '31',   name: 'Netherlands',                  maxDigits: 9  },
  { iso: 'nz', code: '64',   name: 'New Zealand',                  maxDigits: 10 },
  { iso: 'ni', code: '505',  name: 'Nicaragua',                    maxDigits: 8  },
  { iso: 'ne', code: '227',  name: 'Niger',                        maxDigits: 8  },
  { iso: 'ng', code: '234',  name: 'Nigeria',                      maxDigits: 10 },
  { iso: 'kp', code: '850',  name: 'North Korea',                  maxDigits: 10 },
  { iso: 'mk', code: '389',  name: 'North Macedonia',              maxDigits: 8  },
  { iso: 'no', code: '47',   name: 'Norway',                       maxDigits: 8  },
  { iso: 'om', code: '968',  name: 'Oman',                         maxDigits: 8  },
  { iso: 'pk', code: '92',   name: 'Pakistan',                     maxDigits: 10 },
  { iso: 'pw', code: '680',  name: 'Palau',                        maxDigits: 7  },
  { iso: 'ps', code: '970',  name: 'Palestine',                    maxDigits: 9  },
  { iso: 'pa', code: '507',  name: 'Panama',                       maxDigits: 8  },
  { iso: 'pg', code: '675',  name: 'Papua New Guinea',             maxDigits: 8  },
  { iso: 'py', code: '595',  name: 'Paraguay',                     maxDigits: 9  },
  { iso: 'pe', code: '51',   name: 'Peru',                         maxDigits: 9  },
  { iso: 'ph', code: '63',   name: 'Philippines',                  maxDigits: 10 },
  { iso: 'pl', code: '48',   name: 'Poland',                       maxDigits: 9  },
  { iso: 'pt', code: '351',  name: 'Portugal',                     maxDigits: 9  },
  { iso: 'pr', code: '1787', name: 'Puerto Rico',                  maxDigits: 10 },
  { iso: 'qa', code: '974',  name: 'Qatar',                        maxDigits: 8  },
  { iso: 'ro', code: '40',   name: 'Romania',                      maxDigits: 9  },
  { iso: 'ru', code: '7',    name: 'Russia',                       maxDigits: 10 },
  { iso: 'rw', code: '250',  name: 'Rwanda',                       maxDigits: 9  },
  { iso: 'kn', code: '1869', name: 'Saint Kitts & Nevis',          maxDigits: 10 },
  { iso: 'lc', code: '1758', name: 'Saint Lucia',                  maxDigits: 10 },
  { iso: 'vc', code: '1784', name: 'Saint Vincent',                maxDigits: 10 },
  { iso: 'ws', code: '685',  name: 'Samoa',                        maxDigits: 7  },
  { iso: 'sm', code: '378',  name: 'San Marino',                   maxDigits: 10 },
  { iso: 'st', code: '239',  name: 'São Tomé & Príncipe',          maxDigits: 7  },
  { iso: 'sa', code: '966',  name: 'Saudi Arabia',                 maxDigits: 9  },
  { iso: 'sn', code: '221',  name: 'Senegal',                      maxDigits: 9  },
  { iso: 'rs', code: '381',  name: 'Serbia',                       maxDigits: 9  },
  { iso: 'sc', code: '248',  name: 'Seychelles',                   maxDigits: 7  },
  { iso: 'sl', code: '232',  name: 'Sierra Leone',                 maxDigits: 8  },
  { iso: 'sg', code: '65',   name: 'Singapore',                    maxDigits: 8  },
  { iso: 'sk', code: '421',  name: 'Slovakia',                     maxDigits: 9  },
  { iso: 'si', code: '386',  name: 'Slovenia',                     maxDigits: 8  },
  { iso: 'sb', code: '677',  name: 'Solomon Islands',              maxDigits: 7  },
  { iso: 'so', code: '252',  name: 'Somalia',                      maxDigits: 8  },
  { iso: 'za', code: '27',   name: 'South Africa',                 maxDigits: 9  },
  { iso: 'kr', code: '82',   name: 'South Korea',                  maxDigits: 11 },
  { iso: 'ss', code: '211',  name: 'South Sudan',                  maxDigits: 9  },
  { iso: 'es', code: '34',   name: 'Spain',                        maxDigits: 9  },
  { iso: 'lk', code: '94',   name: 'Sri Lanka',                    maxDigits: 9  },
  { iso: 'sd', code: '249',  name: 'Sudan',                        maxDigits: 9  },
  { iso: 'sr', code: '597',  name: 'Suriname',                     maxDigits: 7  },
  { iso: 'se', code: '46',   name: 'Sweden',                       maxDigits: 10 },
  { iso: 'ch', code: '41',   name: 'Switzerland',                  maxDigits: 9  },
  { iso: 'sy', code: '963',  name: 'Syria',                        maxDigits: 9  },
  { iso: 'tw', code: '886',  name: 'Taiwan',                       maxDigits: 9  },
  { iso: 'tj', code: '992',  name: 'Tajikistan',                   maxDigits: 9  },
  { iso: 'tz', code: '255',  name: 'Tanzania',                     maxDigits: 9  },
  { iso: 'th', code: '66',   name: 'Thailand',                     maxDigits: 9  },
  { iso: 'tl', code: '670',  name: 'Timor-Leste',                  maxDigits: 8  },
  { iso: 'tg', code: '228',  name: 'Togo',                         maxDigits: 8  },
  { iso: 'to', code: '676',  name: 'Tonga',                        maxDigits: 7  },
  { iso: 'tt', code: '1868', name: 'Trinidad & Tobago',            maxDigits: 10 },
  { iso: 'tn', code: '216',  name: 'Tunisia',                      maxDigits: 8  },
  { iso: 'tr', code: '90',   name: 'Turkey',                       maxDigits: 10 },
  { iso: 'tm', code: '993',  name: 'Turkmenistan',                 maxDigits: 8  },
  { iso: 'tv', code: '688',  name: 'Tuvalu',                       maxDigits: 6  },
  { iso: 'ug', code: '256',  name: 'Uganda',                       maxDigits: 9  },
  { iso: 'ua', code: '380',  name: 'Ukraine',                      maxDigits: 9  },
  { iso: 'ae', code: '971',  name: 'United Arab Emirates',         maxDigits: 9  },
  { iso: 'gb', code: '44',   name: 'United Kingdom',               maxDigits: 10 },
  { iso: 'us', code: '1',    name: 'United States',                maxDigits: 10 },
  { iso: 'uy', code: '598',  name: 'Uruguay',                      maxDigits: 9  },
  { iso: 'uz', code: '998',  name: 'Uzbekistan',                   maxDigits: 9  },
  { iso: 'vu', code: '678',  name: 'Vanuatu',                      maxDigits: 7  },
  { iso: 've', code: '58',   name: 'Venezuela',                    maxDigits: 10 },
  { iso: 'vn', code: '84',   name: 'Vietnam',                      maxDigits: 10 },
  { iso: 'ye', code: '967',  name: 'Yemen',                        maxDigits: 9  },
  { iso: 'zm', code: '260',  name: 'Zambia',                       maxDigits: 9  },
  { iso: 'zw', code: '263',  name: 'Zimbabwe',                     maxDigits: 9  },
];

/* =========================  Formatting  ========================= */
export function formatBR(digits: string) {
  const d = onlyDigits(digits).slice(0, 11);
  const has9 = d.length >= 11;
  const ddd = d.slice(0, 2);
  const p1 = d.slice(2, has9 ? 7 : 6);
  const p2 = d.slice(has9 ? 7 : 6);
  if (!ddd) return '';
  if (!p1) return `(${ddd}`;
  if (!p2) return `(${ddd}) ${p1}`;
  return `(${ddd}) ${p1}-${p2}`;
}

export function formatNA(digits: string) {
  const d = onlyDigits(digits).slice(0, 10);
  const area = d.slice(0, 3);
  const p1 = d.slice(3, 6);
  const p2 = d.slice(6);
  if (!area) return '';
  if (!p1) return `(${area}`;
  if (!p2) return `(${area}) ${p1}`;
  return `(${area}) ${p1}-${p2}`;
}

export function formatGeneric(digits: string) {
  const d = onlyDigits(digits);
  if (d.length <= 4) return d;
  return d.slice(0, d.length - 4) + '-' + d.slice(d.length - 4);
}

export function formatPhone(country: Country, digits: string): string {
  if (country.code === '55') return formatBR(digits);
  if (country.code === '1') return formatNA(digits);
  return formatGeneric(digits);
}

export function toE164(country: Country, digits: string) {
  const d = onlyDigits(digits);
  const minLen = country.code === '55' ? 10 : country.code === '1' ? 10 : 7;
  if (d.length < minLen) return '';
  return `+${country.code}${d}`;
}

export function isProbablyPhone(raw: string) {
  return /^\d{7,}$/.test(onlyDigits(raw));
}

export function findCountryByCode(dialCode: string): Country {
  return COUNTRIES.find(c => c.code === dialCode) ?? COUNTRIES.find(c => c.iso === 'br')!;
}

export function findCountryByIso(iso: string): Country {
  return COUNTRIES.find(c => c.iso === iso) ?? COUNTRIES.find(c => c.iso === 'br')!;
}

export function phonePlaceholder(country: Country): string {
  if (country.code === '55') return '(11) 91234-5678';
  if (country.code === '1') return '(647) 123-4567';
  return '912345678';
}
